<template>
  <page-template >
    <template slot="page-content">
      <div class="generic--template page-template bg-beige">
         <!-- CONTENT -->
        <div class="relative z-content pv4">
          <div class="relative container-fluid mw9 center tl">
            <h1 class="f-page-title mv0 ttu tl lh-title f2 f1-ns is-blenny is-navy">{{ page.title }}</h1>
          </div>
          <section class="relative">
            <div class="relative container-fluid mw9 center">
              <div class="row mt4 mt3-ns">
                <div class="col-xs-12 col-sm-6 mb4 mb0-ns" v-for="item in page.admat_section.admats">
                  <div class="relative center ph3">
                    <h2 class="f2 f1-ns mv2 tc is-lorano-bold is-navy">{{ item.title }}</h2>
                    <img class="db relative mv3 center mw-100 admat-border" v-lazy="item.image" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
// import SignupForm from './signup-form.vue';
import BgVimeoVideo from './bg-vimeo-video.vue';
export default {
  components: {
    PageTemplate,
    // SignupForm,
    BgVimeoVideo
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
      swiperOptions: {
          autoplay: {
            delay: 7000,
          },
          speed: 800,
          autoplayDisableOnInteraction: false,
          // loop: true,
          initialSlide: 0,
          //pagination: '.swiper-pagination',
          paginationClickable: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          keyboardControl: true,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // },
          initialSlide: 0,
          spaceBetween: 15,
          freeMode: false,
          slidesPerView: 1.3,
        }
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    },
    swiper() {
      if(this.$refs.mySwiper)
        return this.$refs.mySwiper.swiper
    },
  },
  methods : {
    scrollBg: function() {
      //
    },
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
      this.scrollBg();
      if(this.swiper)
        this.swiper.update();
    },
    calcParallax: function(myTarget, offset, movement, positioning){
      if(this.$refs[myTarget]){
        this.parallax2 = false;
        if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
          var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
          return 'top:'+newMovement+'px;'+positioning;
        } else {
          return 'display:none;';
        }
      }
    },
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.sizing);
    //window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.sizing);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    this.$nextTick(() => {
      //
    })

  },
  beforeDestroy() {
    var elem = this.$refs.embedContainer.children[1];
    //console.log('elem: ', this.$refs.embedContainer.children[1]);
    elem.parentNode.removeChild(elem);

    var doStuffJs = document.getElementById('ds-fest-lineup-js');

    //console.log('beforeDestroy - 2', doStuffJs);
    doStuffJs.parentNode.removeChild(doStuffJs);
    
    var doStuffFestJs = document.getElementById('ds-fest');
  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
